import styled, { css } from 'styled-components';
import { H1smallDesktop, nonResponsiveParagraph } from '../../../../theme/typography';
import { Input as InputBase } from '../../../../shared/components/input';
import { Button } from '../../../../shared/components/button';

const GUTTER = 32;

export const Form = styled.form``;

export const Title = styled(H1smallDesktop)`
  margin-bottom: ${GUTTER}px;
`;

export const Description = styled.span`
  ${nonResponsiveParagraph};
  margin-bottom: 40px;
`;

export const Input = styled(InputBase).attrs(() => ({
  light: true,
  containerStyles: css`
    margin-top: ${GUTTER}px;
  `,
}))`
  border-radius: 0;
`;

export const SubmitButton = styled(Button)`
  margin-top: ${GUTTER}px;
`;
